import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/division-form.schema';
import { DivisionForm } from './components/division-form';
import { useCreateDivisionMutation } from '../mutations';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export function Page() {
  const mutation = useCreateDivisionMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync({ ...payload }), {
      success: 'Divisionen har skapats',
      pending: 'Skapar divisionen...',
    });
    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa division" />

      <PageLayout.Section>
        <DivisionForm onSubmit={onSubmit} isLoading={mutation.isPending} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
}
